import React from 'react';

export default function LanguageToggle({ language, onChange, className = '' }) {
  return (
    <div className={`lang-toggle ${className}`.trim()} role="group" aria-label="Language">
      <button
        type="button"
        className={`lang-toggle-btn${language === 'en' ? ' active' : ''}`}
        onClick={() => onChange('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-toggle-btn${language === 'es' ? ' active' : ''}`}
        onClick={() => onChange('es')}
      >
        ES
      </button>
    </div>
  );
}
